import { makeDate } from './utils';

export default {
    monthlyCost: state => {
        const { profile } = state;
        if (!(profile && profile.plans)) {
            return 0;
        }
        return profile.plans.reduce((acc, plan) => {
            return acc + parseFloat(plan.planMaster.ncfPrice) + parseFloat(plan.planMaster.tariff)}, 0
        ) * 1.18
    },
    basePacks: state => {
        const { profile } = state;
        if (!profile || !profile.plans) return [];
        const { plans } = profile;
        const basePlans = plans.filter(p => p.plan_CODE.match(/^BST/));
        basePlans.sort((a, b) => {
            const aDate = makeDate(a.end_DATE);
            const bDate = makeDate(b.end_DATE);
            return aDate > bDate ? -1 : 1;
        });
        return basePlans;
    },
    basePack: (state, getters) => {
        const basePacks = getters.basePacks;
        const currDate = new Date();
        const activePack = basePacks.find(({ end_DATE: endDate }) => {
            return currDate < makeDate(endDate);
        });
        if(activePack) return activePack;
        basePacks.sort((a, b) => {
            const aDate = makeDate(a.end_DATE);
            const bDate = makeDate(b.end_DATE);
            return aDate < bDate ? -1 : 1;
        })
        if(basePacks && basePacks.length > 0)
            return {
                ...basePacks[0],
                expired: true
            };
        return null;
    },
    regionCode: state => {
        if(state.userProfile && state.userProfile.district_CODE)
            return state.userProfile.district_CODE;
        return '';
    },
    userId: state => {
        return state.id
    },
    isAdmin: state => {
        const { roles } = state;
        if (Array.isArray(roles)) {
            const doc = roles.find(r => r.code === 'ROLE_ADMIN')
            return doc !== null && doc !== undefined;
        }
        return false;
    },
    isDP: state => state.dp === true
}